<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <router-link :to="'/users/detail/info?userid='+ form.user_id">
          <el-breadcrumb-item>{{$route.meta.title}} userid={{form.user_id}}</el-breadcrumb-item>
        </router-link>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               label-width="150px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-col style="text-align:center">
            <a :href="form.photo"
               target="_Blank"
               v-if="form.photo">
              <img :src="form.photo+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                   width="100px;"
                   height="100px;"
                   style="border-radius:50px">
            </a>
          </el-col>
          <br/>
          <Br/>
          <el-col>
            <el-form-item label="姓名:">{{form.name}}</el-form-item>
            <el-form-item label="性别:">
              <span v-for="item in options.genders"
                    v-if="item.id === form.gender">{{item.text}}</span>
            </el-form-item>
            <el-form-item label="出生年月:">{{form.brithdate}}</el-form-item>
            <el-form-item label="所在城市:">{{form.address}}</el-form-item>
            <el-form-item label="身高:">{{form.height}} cm</el-form-item>
            <el-form-item label="学历:">
              <span v-for="item in options.educations"
                    v-if="item.id === form.education">{{item.text}}</span>
            </el-form-item>
            <el-form-item label="联系电话:">{{form.phone_number}}</el-form-item>
          </el-col>
        </el-row>
        <br>

        <el-row class="text item">
          <el-col :span="24">
            <h2>工作经验</h2>
            <hr>
          </el-col>

          <el-form-item label="从事过岗位:">
            <span v-for="working_experiences in form.working_experiences">
              <span v-for="item in options.working_experiences"
                    v-if="item.id === working_experiences.id && working_experiences.id !== 99">{{item.text}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="working_experiences.id === 99">{{working_experiences.text}}</span>
            </span>
          </el-form-item>
          <el-form-item label="工作经验:">
            <span v-for="item in options.working_experience_ages"
                  v-if="item.id === form.working_experience_age">{{item.text}}</span>
          </el-form-item>
        </el-row>
        <Br/>

        <el-row class="text item">
          <el-col :span="24">
            <h2>求职意向</h2>
            <hr>
          </el-col>
          <el-form-item label="工作性质:">
            <span v-for="item in options.time_periods"
                  v-if="item.id === form.expect_time_period">{{item.text}}</span>
          </el-form-item>
          <el-form-item label="期望从事行业大类:">
            <span v-for="item in options.industries"
                  v-if="item.id === form.expect_industry_type">{{item.text}}</span>
          </el-form-item>
          <el-form-item label="期望工作地点:">
            <span v-if="form.expect_city_info">{{form.expect_city_info.city_name}}</span>
          </el-form-item>
          <el-form-item label="期望薪资:">
            <span v-for="item in options.salary_range"
                  v-if="item.id === form.expect_salary_range">{{item.text}}</span>
          </el-form-item>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>技能/证书/证件</h2>
            <hr>
          </el-col>
          <el-form-item label="证件类别:">
            <span v-for="certificates in form.certificates">
              <span v-for="item in options.certificates"
                    v-if="item.id === certificates.id && certificates.id !== 99">{{item.text}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="certificates.id === 99">{{certificates.text}}</span>
            </span>
          </el-form-item>
        </el-row>
        <br/>

        <el-row class="text item">
          <el-col :span="24">
            <h2>自我介绍</h2>
            <hr>
          </el-col>
          {{form.self_introduce}}
        </el-row>
        <br>
        <el-col :span="8"
                :offset="6">
          <Br/><br/>
          <el-button type="primary"
                     @click="onExport()">下载简历
          </el-button>&nbsp;&nbsp;&nbsp;&nbsp;

          <router-link :to="{path: '/resume/form/'+form.resume_id}">
            <el-button>编辑</el-button>
          </router-link>
          <router-link :to="{path: '/resume/all_table'}">
            <el-button>返回</el-button>
          </router-link>
        </el-col>

      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      id: this.$route.query.id,
      positionId: this.$route.query.position_id,
      form: {
        user_id: null,
        resume_id: null,
        name: null,
        gender: null,
        brithdate: null,
        address: null,
        domicile: null,
        height: null,
        education: null,
        photo: null,
        phone_number: null,
        working_experiences: [],
        working_experience_age: null,
        certificates: [],
        self_introduce: '', // 自我介绍
        expect_industry_type: null,
        expect_city_name: null,
        expect_salary_range: null,
        expect_time_period: null,
        expect_city_info: [],
      },
      options: {
        genders: [],
        educations: [],
        cities: [],
        industries: [],
        salary_range: [],
        position: [],
        experience: [],
        certificates: [],
        expect_cities: [],
        working_experiences: [],
        working_experience_age: [],
        time_periods: [],
        working_experience_ages: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getResumeOptions'),
      request('getResumeForm', this.id),
    ]).then(([options, form]) => {
      ((data) => {
        filter.setLoop(this.options, data.data)
      })(options)
      ;((data) => {
        filter.setLoop(this.form, data.data)
      })(form)
    })
  },
  methods: {
    ...Vuex.mapActions(['getResumeForm', 'exportResumes', 'downloadResume', 'getResumeCity']),

    onExport () {
      let loadingInstance = Loading.service({fullscreen: true})

      request.common('exportResumes', {resume_ids: [this.form.resume_id]}).then((data) => {
        loadingInstance.close()
        request.common('downloadResume', data.data.file)
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/resume/pages/ResumeAllDetail.vue